/* eslint-disable  */
import { makeStyles } from '@material-ui/core/styles';
import { uniqBy, uniq } from 'lodash';

const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        width: 300
    },
    indeterminateColor: {
        color: '#f50057'
    },
    selectAllText: {
        fontWeight: 500
    },
    selectedAll: {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)'
        }
    }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250
        }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
    },
    variant: 'menu'
};

const getCorrectFloorNo = (_unitNumber, lookup_code) => {
    
    let unitNumber = _unitNumber.toString();


    if (lookup_code === '121') {

        return 1;
    }

    if (lookup_code === '081' || lookup_code === '81') {

        if (unitNumber.charAt(1) === '0') {
            return parseInt(unitNumber.charAt(2))
        } else {
            return parseInt(unitNumber.charAt(1))
        }
    }



    if (unitNumber.charAt(0) === '0'){
        
        unitNumber = unitNumber.slice(1, unitNumber.length)
    }

   
    let unitNumberNoStudio = unitNumber 
    if ( !parseInt(unitNumber.slice(-1))){ 
       unitNumberNoStudio = unitNumber.substring(0, unitNumber.length-1); 
    }


    if (unitNumberNoStudio.length > 3) {

        return parseInt(unitNumber.slice(0,2))      

    }
    else {

        return parseInt(unitNumber.slice(0,1))
    }
}


const getFilterValues = (orders = []) => {

    // console.log(orders)

    const floors = uniq(orders.map((o) => {
         
        return getCorrectFloorNo(o.unit, o.lookup_code)
        //  if (!floorNo) {
        //     console.log(o)
        //  }
    }));
    const unitTypes = uniq(orders.map(o => o.unit_type));
    const buildings = uniq(orders.map(o => o.building));

    return {
        floors,
        unitTypes,
        buildings
    };
};


const getUniqueAmenityNames = (orders = []) => (

    uniqBy(orders.map(order => order.amenity_name, 'amenity_name'))
);

export {
    useStyles,
    MenuProps,
    getUniqueAmenityNames,
    getFilterValues
};
